<template>
  <v-row no-gutters>
    <v-col v-if="reportData && reportData.length > 0" class="pa-0">
      <v-col
        class="deliveryReport pa-0 mb-10"
        v-for="(item, index1) in reportData"
        :key="index1"
      >
        <div class="deliveryReport-header row ma-0">{{ title }}</div>
        <div class="deliveryReport-content">
          <v-row
            class="deliveryReport-contentRow"
            no-gutters
            v-for="(item, index) in reportData[index1].data"
            :key="index"
          >
            <v-col sm="6">
              <span>{{ item.label }}:</span>
            </v-col>
            <v-col sm="6">
              <span v-if="item.value" class="wrap-text">{{ item.value }}</span>
              <span v-else class="not-available-text wrap-text">{{
                item.notAvailableText
              }}</span>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['reportData', 'title'],
  data() {
    return {};
  },

  methods: {}
};
</script>

<style>
.wrap-text {
  word-break: break-all;
}
</style>
<style scoped>
.not-available-text {
  font-style: italic;
  color: rgba(27, 35, 66, 0.6);
}
</style>
